import {useState, useEffect} from "react";
import {
  IEsgProjectWithSegmentsFromServer,
  IEsgResponseFromCMS,
  IEsgSegmentWithLayerFromServer,
} from "../pages/Esg/EsgDashboard.type";

const useFetchDataEsg = (
  apiUrlProjects: string,
  apiUrlSegments: string,
  idEsg: string,
  apiKey: string
) => {
  const [projectsData, setProjectsData] = useState<IEsgResponseFromCMS<
    IEsgProjectWithSegmentsFromServer[]
  > | null>(null);
  const [segmentsData, setSegmentsData] = useState<IEsgResponseFromCMS<
    IEsgSegmentWithLayerFromServer[]
  > | null>(null);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const headers = new Headers({
      Authorization: `Bearer ${apiKey}`,
      "Content-Type": "application/json",
    });

    const projectsUrl = new URL(apiUrlProjects);
    const segmentsUrl = new URL(apiUrlSegments);

    projectsUrl.searchParams.set("[populate][segment][populate]", "layer");
    projectsUrl.searchParams.set(
      "filters[segment][layer][documentId][$eq]",
      idEsg
    );
    projectsUrl.searchParams.set("pagination[pageSize]", "500");

    segmentsUrl.searchParams.set("populate", "layer");
    segmentsUrl.searchParams.set("filters[layer][documentId][$eq]", idEsg);

    Promise.all([
      fetch(projectsUrl.href, {headers}).then((response) => response.json()),
      fetch(segmentsUrl.href, {headers}).then((response) => response.json()),
    ])
      .then(([projectsData, segmentsData]) => {
        setProjectsData(projectsData);
        setSegmentsData(segmentsData);
      })
      .catch((error) => {
        setError(error);
      });
  }, [apiUrlProjects, apiUrlSegments, idEsg, apiKey]);
  return {projectsData, segmentsData, error};
};

export default useFetchDataEsg;
